import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

import getBoard, { importBoard } from "../moodboardModel";
import CustomCardContent from "./CustomCardContent";
import CustomCardHeader from "./CustomCardHeader";
import CustomCardFooter from "./CustomCardFooter";
import Description from "./Description";
import getSettings from "../moodboardSettings";

export default function Board({
  variant,
  rom,
  item,
  handleItem = (arg) => false,
}) {
  const { t } = useTranslation();
  const [moodboard, setMoodboard] = useState(getBoard({}));
  const [initialMoodboard, setInitialMoodboard] = useState(moodboard);
  const [beeps, setBeeps] = useState(rom);
  const [loading, setLoading] = useState(true);
  const settings = getSettings(moodboard);
  useEffect(() => {
    if (rom) {
      const board = importBoard(item, rom);
      setMoodboard(board);
      setInitialMoodboard(board);
      setBeeps(rom);
      setLoading(false);
    }
  }, [item, rom]);
  const handleMoodboard = (data) =>
    setMoodboard((prev) => {
      const newBoard = { ...prev, ...data };
      handleItem(newBoard);
      return newBoard;
    });

  //console.log("moodboard");
  //console.log(moodboard);

  const handleSetting = ({ type, id, link, value }) => {
    switch (type) {
      case "switch":
        handleMoodboard({ [id]: !moodboard[id] });
        break;
      case "link":
        window.open(link, "_blank");
        break;
      case "clockViewButton":
      case "timeViewButton":
      case "networkViewButton":
        handleMoodboard({ [id]: value });
        break;
      default:
        break;
    }
  };

  if (!loading)
    return (
      <Grow in={true} {...{ timeout: variant === "timeline" ? 0 : 1000 }}>
        <Paper
          variant={variant === "timeline" ? "outlined" : "elevation"}
          style={{
            width: "100%",
            padding: variant === "timeline" ? 0 : 16,
            border: 0,
          }}
          id={`board-${item.id}`}
        >
          <CustomCardHeader
            variant={variant}
            timeRange={`${moment(beeps.history[0]?.time).format("D MMM")} - ${
              moodboard.update
                ? t("moodboards.settings.now")
                : moment(beeps.history[beeps.history.length - 1]?.time).format(
                    "D MMM"
                  )
            }`}
            moodboard={moodboard}
            handleMoodboard={handleMoodboard}
            settings={settings}
            handleSetting={handleSetting}
          />
          {variant !== "timeline" ? <Box padding={1} /> : null}
          <CustomCardContent
            variant={variant}
            rom={beeps}
            moodboard={moodboard}
            initialMoodboard={initialMoodboard}
          />

          <Description
            description={moodboard.description}
            initExpand={moodboard.expandDescription}
          />
          {variant === "analyser" ? (
            <CustomCardFooter
              moodboard={moodboard}
              handleMoodboard={handleMoodboard}
              settings={settings}
              handleSetting={handleSetting}
            />
          ) : null}
        </Paper>
      </Grow>
    );
  return "";
}
